import { api, handleResponse, handleError } from "./apiServices";
const baseURL = "/api/v1/venue/";

export const getProfile = token =>
  api(token)
    .get(`${baseURL}profile`)
    .then(handleResponse)
    .catch(handleError);

export const updateProfile = (token, data) =>
  api(token)
    .put(`${baseURL}editprofile`, data)
    .then(handleResponse)
    .catch(handleError);

export const changePassword = (token, id, data) =>
  api(token)
    .post(`${baseURL}change-password`, data)
    .then(handleResponse)
    .catch(handleError);

export const resetPassword = data =>
  api()
    .post(`${baseURL}resetpassword`, data)
    .then(handleResponse)
    .catch(handleError);

export const forgotPassword = data =>
  api()
    .post(`${baseURL}forgetpassword`, data)
    .then(handleResponse)
    .catch(handleError);

export const sendAccessKey = (token, id) =>
  api(token)
    .post(`${baseURL}send_access_key`, id)
    .then(handleResponse)
    .catch(handleError);
